import React from "react"; // Required for JSX even if not explicitly used
import { useState } from 'react';
import ToggleSettingRow from '../ToggleSettingRow'; // Adjust path
import { Button } from '../ui/button';

interface CommunicationSettingsProps {
  initialSettings: {
    allowMessagesFriends: boolean;
    allowMessagesNonFriends: boolean;
    allowCalls: boolean;
  } | null;
  onSave: (settings: {
    allowMessagesFriends: boolean;
    allowMessagesNonFriends: boolean;
    allowCalls: boolean;
  }) => void;
  onCancel: () => void;
}

export default function CommunicationSettings({ initialSettings, onSave, onCancel }: CommunicationSettingsProps) {
  // Manage local state for toggles
  const [settings, setSettings] = useState(initialSettings || {
    allowMessagesFriends: true,
    allowMessagesNonFriends: true,
    allowCalls: true,
  });

  const handleToggleChange = (id: string, checked: boolean) => {
    setSettings(prev => ({ ...prev, [id]: checked }));
  };

  // Supabase Integration Point: Call onSave with the settings data
  const handleSave = () => {
      console.log("Saving communication settings:", settings);
      if (onSave) onSave(settings);
      // Typically navigate back or show confirmation after save
  };

  // Supabase Integration Point: Discard changes and revert
   const handleCancel = () => {
      console.log("Canceling changes");
      // Revert to initial state or navigate back without saving
      setSettings(initialSettings || { // Reset to original or default
           allowMessagesFriends: true,
           allowMessagesNonFriends: true,
           allowCalls: true,
      });
       if (onCancel) onCancel();
       // Typically navigate back
   };


  return (
    <div className="jr-card jr-screen-pad mt-4 flex flex-col overflow-hidden px-0">
      <ToggleSettingRow
        label="Allow Messages from Friends"
        id="allowMessagesFriends"
        checked={settings.allowMessagesFriends}
        onCheckedChange={(c) => handleToggleChange('allowMessagesFriends', c)}
      />
      <ToggleSettingRow
        label="Allow Messages from Non-Friends"
        id="allowMessagesNonFriends"
        checked={settings.allowMessagesNonFriends}
        onCheckedChange={(c) => handleToggleChange('allowMessagesNonFriends', c)}
      />
      <ToggleSettingRow
        label="Allow Calls"
        id="allowCalls"
        checked={settings.allowCalls}
        onCheckedChange={(c) => handleToggleChange('allowCalls', c)}
      />

      {/* Save/Cancel Buttons */}
       <div className="flex space-x-4 p-4">
           <Button onClick={handleSave} className="jr-action-primary h-auto flex-1 min-h-11">Save</Button>
           <Button onClick={handleCancel} variant="outline" className="jr-action-secondary h-auto flex-1 min-h-11">Cancel</Button>
       </div>
    </div>
  );
}
